import { loadEnv } from '../../shims/load-env';

export const ANTHROPIC_API_KEY_ENV_VARIABLE_NAME = 'ANTHROPIC_API_KEY';
export const ANTHROPIC_BASE_URL_ENV_VARIABLE_NAME = 'ANTHROPIC_BASE_URL';
export const ANTHROPIC_DEFAULT_MODEL_ENV_VARIABLE_NAME =
  'ANTHROPIC_DEFAULT_MODEL';

export const DEFAULT_ANTHROPIC_MODEL = 'claude-3-7-sonnet-latest';
export const DEFAULT_ANTHROPIC_MAX_TOKENS = 4096;
export const DEFAULT_ANTHROPIC_TIMEOUT_MS = 60 * 60 * 1000;

export function getDefaultAnthropicKey(): string | undefined {
  return loadEnv()[ANTHROPIC_API_KEY_ENV_VARIABLE_NAME];
}

export function getDefaultAnthropicBaseURL(): string | undefined {
  return loadEnv()[ANTHROPIC_BASE_URL_ENV_VARIABLE_NAME];
}

export function getDefaultAnthropicModel(): string {
  return (
    loadEnv()[ANTHROPIC_DEFAULT_MODEL_ENV_VARIABLE_NAME] ??
    DEFAULT_ANTHROPIC_MODEL
  );
}
